import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  plazasJefes: {},
}

export default function plazasJefesReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_PLAZAS_JEFES:
      return {...state, loading: action.payload}
    case actions.GET_PLAZAS_JEFES:
       
      return {...state, plazasJefes: action.payload}
    default:
      return state
  }
}